
/**
 * This class contains all the configuration for the sdk.
 */
class SdkConfiguration {

  /**
   * Contains the current domain of the front.
   * Used to set absolute path for resources (pictures, etc)
   */
  setDomainUrl(domain) {
    this.domainUrl = domain;
  }

  getDomainUrl() {
    return this.domainUrl;
  }
}

export default new SdkConfiguration()



// WEBPACK FOOTER //
// ./sdk/scripts/utils/SdkConfiguration.js